import { ProductSubCategoryEnum } from "@shared/enums";
import { CheckboxFilterElement } from "./checkboxFilter.element";

export class AbFilterSubCategoryElement extends CheckboxFilterElement<ProductSubCategoryEnum> {
  constructor() {
    super({ label: "Categoria", eventName: "sub-category-filter-change", optionLabel: (value) => value });
  }
}

export const defineAbFilterSubCategoryElement = () => {
  if (!customElements.get("ab-filter-sub-category")) customElements.define("ab-filter-sub-category", AbFilterSubCategoryElement);
};
